import { Chip } from "@mui/material";
import React from "react";

import colors from "../../../config/colors";
import { StatusTone } from "../controllers/use-supervisor-queue";

const TONE_STYLES: Record<StatusTone, { backgroundColor: string; color: string }> =
	{
		error: { backgroundColor: colors.errorBox, color: colors.delete },
		warning: { backgroundColor: colors.noticeBox, color: colors.noticeText },
		info: { backgroundColor: colors.infoBox, color: colors.infoText },
		neutral: { backgroundColor: colors.grey, color: colors.title },
	};

interface StatusChipProps {
	label: string;
	tone: StatusTone;
}

function StatusChip({ label, tone }: StatusChipProps) {
	return (
		<Chip
			label={label}
			size='small'
			sx={{
				...TONE_STYLES[tone],
				fontWeight: 500,
				fontSize: "0.75rem",
			}}
		/>
	);
}

export default StatusChip;
